import "./locationAdminDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface LocationAdminDetailsViewComponentProps {
    locationAdminDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationAdminDetailsViewComponent = (props: LocationAdminDetailsViewComponentProps) => {
    const {locationAdminDetails, onEditModeOpen, canEdit} = props;

    return (
        <div className={'admin-details-view-component details-tab-data-content'}>
            {/*{locationAdminDetails && <>*/}
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Basic Details</div>
                {
                    canEdit &&
                    <div className={'edit-action-button'}>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={false}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                }
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"NPI Number"}> {locationAdminDetails?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Middle Name"}> {locationAdminDetails?.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"First Name"}> {locationAdminDetails?.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Last Name"}> {locationAdminDetails?.lastName || 'N/A'} </DetailsDataKeyValueComponent>

                    </Grid>
                </Grid>

                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Contact Details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Email ID"}> {locationAdminDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Fax Number"}> {locationAdminDetails?.faxNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(locationAdminDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Address Details</div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 1"}> {locationAdminDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"ZIP Code"}> {locationAdminDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"State"}> {locationAdminDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 2"}> {locationAdminDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"City"}> {locationAdminDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>

                </>
            </div>
            {/*</>}*/}
        </div>
    );

};

export default LocationAdminDetailsViewComponent;
